import { combineReducers } from 'redux';
import api from './api';
import trip from './trip';
import tripDetails from './tripDetails';
import slider from './slider';
import booking from './booking';
import lightbox from './lightbox';
import faq from './faq';
import stories from './stories';
import pastExperiences from './pastExperiences';
import auth from './auth';
import myBookings from './myBookings';
import reviews from './reviews';
import contest from './contest';

const rootReducer = combineReducers({
  apiState: api,
  sliderState: slider,
  tripState: trip,
  tripDetailsState: tripDetails,
  bookingState: booking,
  lightboxState: lightbox,
  faqState: faq,
  storiesState: stories,
  pastExperiencesState: pastExperiences,
  authState: auth,
  myBookingsState: myBookings,
  reviewsState: reviews,
  contestState: contest
});

export default rootReducer;
